import { render, staticRenderFns } from "./CashAdvancesSummary.vue?vue&type=template&id=0f2f29e4&scoped=true"
import script from "./CashAdvancesSummary.vue?vue&type=script&lang=js"
export * from "./CashAdvancesSummary.vue?vue&type=script&lang=js"
import style0 from "./CashAdvancesSummary.vue?vue&type=style&index=0&id=0f2f29e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2f29e4",
  null
  
)

export default component.exports